// This file is auto-generated by @hey-api/openapi-ts

export const GlobalSettingsEnum = {
    CUSTOMER_CARD_VALIDITY: 'CUSTOMER_CARD_VALIDITY',
    RECLAMATION_CARD_VALIDITY: 'RECLAMATION_CARD_VALIDITY',
    E_WALLET_MIN_RECHARGE: 'E_WALLET_MIN_RECHARGE',
    E_WALLET_MAX_RECHARGE: 'E_WALLET_MAX_RECHARGE',
    E_WALLET_MAX_AMOUNT: 'E_WALLET_MAX_AMOUNT',
    ESHOP_CARD_EXPIRATION_NOTIFICATION: 'ESHOP_CARD_EXPIRATION_NOTIFICATION',
    ESHOP_TICKET_EXPIRATION_NOTIFICATION: 'ESHOP_TICKET_EXPIRATION_NOTIFICATION',
    ESHOP_CUSTOMER_PROFILE_EXPIRATION_NOTIFICATION: 'ESHOP_CUSTOMER_PROFILE_EXPIRATION_NOTIFICATION',
    TICKET_FARE_RETURN_FEE: 'TICKET_FARE_RETURN_FEE',
    MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_COUNTER: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_COUNTER',
    MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_AFTER_START_AT_COUNTER: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_AFTER_START_AT_COUNTER',
    MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_ESHOP: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_ESHOP',
    RECLAMATION_FINALIZATION_TIME_IN_DAYS: 'RECLAMATION_FINALIZATION_TIME_IN_DAYS',
    E_WALLET_TRANSACTION_TAX_PERCENTAGE: 'E_WALLET_TRANSACTION_TAX_PERCENTAGE',
    VIRTUAL_CARD_VALIDITY: 'VIRTUAL_CARD_VALIDITY',
    VIRTUAL_CARD_MAX_SHORT_TERM_TICKET_FARES_COUNT: 'VIRTUAL_CARD_MAX_SHORT_TERM_TICKET_FARES_COUNT',
    CUSTOMER_PROFILE_DEFAULT_VALID_TO_IN_YEARS: 'CUSTOMER_PROFILE_DEFAULT_VALID_TO_IN_YEARS',
    CUSTOMER_NOTIFICATION_MIN_TICKET_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MIN_TICKET_DAYS_IN_ADVANCE',
    CUSTOMER_NOTIFICATION_MAX_TICKET_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MAX_TICKET_DAYS_IN_ADVANCE',
    CUSTOMER_NOTIFICATION_MIN_CARD_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MIN_CARD_DAYS_IN_ADVANCE',
    CUSTOMER_NOTIFICATION_MAX_CARD_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MAX_CARD_DAYS_IN_ADVANCE',
    CARD_VALIDITY_UPDATE_LIMIT_IN_MONTHS: 'CARD_VALIDITY_UPDATE_LIMIT_IN_MONTHS',
    CUSTOMER_NOTIFICATION_MIN_CUSTOMER_PROFILE_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MIN_CUSTOMER_PROFILE_DAYS_IN_ADVANCE',
    CUSTOMER_NOTIFICATION_MAX_CUSTOMER_PROFILE_DAYS_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MAX_CUSTOMER_PROFILE_DAYS_IN_ADVANCE',
    REWARD_PROGRAM: 'REWARD_PROGRAM',
    CZK_NEEDED_FOR_COMPLEMENTARY_REWARD_POINT: 'CZK_NEEDED_FOR_COMPLEMENTARY_REWARD_POINT',
    CZK_NEEDED_FOR_TICKET_REWARD_POINT: 'CZK_NEEDED_FOR_TICKET_REWARD_POINT',
    NETWORK_ID: 'NETWORK_ID',
    QR_CODE_CARD_VALIDITY_YEARS: 'QR_CODE_CARD_VALIDITY_YEARS',
    OFFENSE_REMINDER_DAYS_BEFORE: 'OFFENSE_REMINDER_DAYS_BEFORE',
    MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_KIOSK: 'MAX_DAYS_BETWEEN_CURRENT_DATE_AND_TICKET_FARE_VALID_FROM_BEFORE_START_AT_KIOSK',
    PROVIDER_ID: 'PROVIDER_ID',
    CUSTOMER_NOTIFICATION_MIN_SINGLE_TICKETS_MINUTES_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MIN_SINGLE_TICKETS_MINUTES_IN_ADVANCE',
    CUSTOMER_NOTIFICATION_MAX_SINGLE_TICKETS_MINUTES_IN_ADVANCE: 'CUSTOMER_NOTIFICATION_MAX_SINGLE_TICKETS_MINUTES_IN_ADVANCE'
} as const;

export type GlobalSettingsEnum = typeof GlobalSettingsEnum[keyof typeof GlobalSettingsEnum];
